import React from 'react';
import { Loader } from '@wix/design-system';
import style from './LoadingScreen.scss';

function LoadingScreen() {
  return (
    <div data-hook="feedback-loader">
      <div className={style.center}>
        <Loader size="medium"></Loader>
      </div>
      <div className={style.opacityLayer}></div>
    </div>
  );
}

export default LoadingScreen;
